import forge from "node-forge";

export const _GetX32 = (message: string): string => {

    try {
      // Recupero la clave pública desde la constante publica
      const publicKeyPem = (window as any).PUBLIC_KEY;
  
      // Convertir el PEM a una clave pública con node-forge
      const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
  
      // Cifrar el mensaje usando la clave pública
      const encrypted = publicKey.encrypt(message);

      const encryptedBase64 = forge.util.encode64(encrypted);
    
      return encryptedBase64;

    } catch (error) {
      console.error('Error cifrando el mensaje:', error);
      throw error;
    }
  };


  export const _GetX64 = (message: string): string => {

    try {
      // Recupero la clave pública desde la constante publica
      const publicKeyPem = (window as any).PUBLIC_KEY;
  
      // Convertir el PEM a una clave pública con node-forge
      const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
  
      // Cifrar el mensaje usando la clave pública
      const encrypted = publicKey.encrypt(message);

      const encryptedBase64 = forge.util.encode64(encrypted);
    
      return encryptedBase64;

    } catch (error) {
      console.error('Error cifrando el mensaje:', error);
      throw error;
    }
  };


  export const _GetX128 = (message: string): string => {

    try {
      // Recupero la clave pública desde la constante publica
      const publicKeyPem = (window as any).PUBLIC_KEY;
  
      // Convertir el PEM a una clave pública con node-forge
      const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
  
      // Cifrar el mensaje usando la clave pública
      const encrypted = publicKey.encrypt(message);

      const encryptedBase64 = forge.util.encode64(encrypted);
    
      return encryptedBase64;

    } catch (error) {
      console.error('Error cifrando el mensaje:', error);
      throw error;
    }
  };

/*
  export function _GetX128(mensaje: string): string {
  try {
    // Recupero la clave pública desde la constante publica
    const publicKeyPem = (window as any).PUBLIC_KEY;
  
    // Convertir la clave pública PEM a un objeto de clave pública
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

    // Convertir el mensaje a bytes
    const buffer = forge.util.createBuffer(mensaje, 'utf8');
    const bytes = buffer.getBytes();

    // Cifrar los bytes del mensaje
    const encrypted = publicKey.encrypt(bytes);

    // Codificar el resultado en base64 para una transmisión segura
    return forge.util.encode64(encrypted);

  } catch (error) {
    console.error('Error al encriptar:', error);
  throw error;
  }
}
*/